// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ViewAll from "@west/XDL/Icons/ViewAll";
import { css } from "styled-components";

const textStyles: TypographyPresentationProps = {
    size: 12,
    weight: "normal",
    color: "text.main",
    ellipsis: true,
    css: css`
        letter-spacing: 0;
        line-height: 16px;
        margin-bottom: 0;
    `,
};

interface AutoCompleteSharedStyles {
    container: InjectableCss;
    headerContainer: InjectableCss;
    headerText: TypographyPresentationProps;
    itemText: TypographyPresentationProps;
    itemLink: LinkPresentationProps;
    focusedItemText: TypographyPresentationProps;
    viewAllLink: LinkPresentationProps;
}

const autoCompleteSharedStyles: AutoCompleteSharedStyles = {
    container: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 12px;
        `,
    },
    headerContainer: {
        css: css`
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            flex-wrap: wrap;
        `,
    },
    headerText: {
        variant: "h6",
        color: "text.main",
        ellipsis: true,
        css: css`
            display: flex;
            justify-content: space-between;
            margin-bottom: 0;
        `,
    },
    itemText: {
        ...textStyles,
    },
    itemLink: {
        color: "text.main",
        typographyProps: {
            ...textStyles,
        },
    },
    focusedItemText: {
        ...textStyles,
    },
    viewAllLink: {
        icon: {
            position: "right",
            iconProps: {
                src: ViewAll,
                size: 12,
                css: css`
                    margin-left: 8px;
                    opacity: 0.66;
                    svg {
                        opacity: 0.66;
                    }
                `,
            },
        },
    },
};

export default autoCompleteSharedStyles;
